import axiosInstance from "../axiosInstance";
import API_ROUTES from "../apiRoutes";

export const EtsyAPI = {
  addAccount: (data) =>
    axiosInstance.post(API_ROUTES.ETSY.CREATE_ACCOUNT, data),

  getAccounts: () => axiosInstance.get(API_ROUTES.ETSY.GET_ACCOUNTS),

  updateAccount: (id, data) =>
    axiosInstance.put(`${API_ROUTES.ETSY.UPDATE_ACCOUNT}/${id}`, data),

  toggleAccount: (id) =>
    axiosInstance.patch(`${API_ROUTES.ETSY.TOGGLE_ACCOUNT}/${id}`),

  toggleAutoUpdate: (id) =>
    axiosInstance.patch(`${API_ROUTES.ETSY.TOGGLE_AUTO_UPDATE}/${id}`),

  deleteAccount: (id) =>
    axiosInstance.delete(`${API_ROUTES.ETSY.DELETE_ETSY_ACCOUNT}/${id}`),

  syncListings: (account_id) =>
    axiosInstance.get(`${API_ROUTES.ETSY.SYNC_LISTINGS}/${account_id}`),

  getListing: (listing_id, account_id) =>
    axiosInstance.get(
      `${API_ROUTES.ETSY.GET_LISTING}/${listing_id}/${account_id}`,
    ),

  getListings: (listing_id, account_id) =>
    axiosInstance.get(
      `${API_ROUTES.ETSY.GET_LISTING}/${listing_id}/${account_id}`,
    ),

  getProductList: (account_id, page = 1, limit = 10, search = "") =>
    axiosInstance.get(
      `${API_ROUTES.ETSY.GET_PRODUCT_LIST}/${account_id}?page=${page}&limit=${limit}&search=${search}`,
    ),

  getProductByListingId: (listing_id) =>
    axiosInstance.get(
      `${API_ROUTES.ETSY.GET_PRODUCT_BY_LISTING_ID}?listing_id=${listing_id}`,
    ),

  updateListing: (listing_id, data) =>
    axiosInstance.put(
      `${API_ROUTES.ETSY.UPDATE_SINGLE_Listing}/${listing_id}`,
      data,
    ),

  pushListingPrice: (listing_id, account_id) =>
    axiosInstance.post(
      `${API_ROUTES.ETSY.UPDATE_PRICE_ON_ETSY}/${listing_id}/${account_id}`,
    ),

  testGoldPrice: () => axiosInstance.get(API_ROUTES.ETSY.TEST_GOLD),
};
